export const SET_CART_DOT = 'SET_CART_DOT'
export const SET_CART_NUM = 'SET_CART_NUM'
export const SET_CART = 'SET_CART'
export const SET_MSGNUM = 'SET_MSGNUM'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js